<template>
  <div id="app" class="noise-grain">
    <PageHeader v-if="showHeader && !shouldHideHeader" />
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import PageHeader from '@/components/PageHeader.vue'

const showHeader = ref(false)

const route = useRoute()

const shouldHideHeader = computed(() => {
  if (!route.meta.hideHeader) {
    return false
  }
  if (typeof route.meta.hideHeader === 'function') {
    return route.meta.hideHeader()
  } else {
    return route.meta.hideHeader
  }
})

onMounted(() => {
  setTimeout(() =>
    showHeader.value = true
  , 500)

  // Apply tint from URL params to body
  const params = new URLSearchParams(window.location.search)
  const tint = params.get('tint')
  if (tint) {
    document.body.setAttribute('data-tint', tint)
  }
})

</script>

<style scoped>

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

</style>
